import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../adminApi';
import { SearchableSelectOption } from '../../../components/SearchableSelect';

export function useCatalogCategoryOptions(value: string, excludedId?: number) {
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('');
  useEffect(() => {
    const timer = window.setTimeout(() => setQuery(search.trim()), 250);
    return () => window.clearTimeout(timer);
  }, [search]);
  const categories = useQuery({ queryKey: ['catalog', 'category-options', query], queryFn: () => adminApi.getCatalogCategories({ search: query, page: 1, per_page: 20 }) });
  const selected = useQuery({ queryKey: ['catalog', 'category', value], queryFn: () => adminApi.getCatalogCategories({ category_id: Number(value), page: 1, per_page: 1 }), enabled: value !== '' });
  const options: SearchableSelectOption[] = [];
  const seenIds = new Set<number>();
  const availableCategories = [...(selected.data?.items ?? []), ...(categories.data?.items ?? [])];
  for (const category of availableCategories) {
    if (category.category_id === excludedId || seenIds.has(category.category_id)) continue;
    seenIds.add(category.category_id);
    const label = category.category_parent_name ? `${category.category_parent_name} / ${category.category_name}` : category.category_name;
    options.push({ value: String(category.category_id), label });
  }
  return { options, setSearch, isLoading: categories.isFetching, error: categories.error ?? selected.error };
}
